export function nextSort(current, columnId) {
    if (current == null || current.name !== columnId) return {
        name: columnId,
        direction: 'desc'
    };
    return {
        name: columnId,
        direction: current.direction === 'desc' ? 'asc' : 'desc'
    };
}
export function toggledSelection(selected, rowId) {
    const next = new Set(selected);
    if (next.has(rowId)) {
        next.delete(rowId);
    } else {
        next.add(rowId);
    }
    return next;
}
